import React from "react";
import { Link } from "react-router-dom";
import Team from "components/team";
import { TTeam } from "components/team/helpers/team-types-helper";
import { Localize } from "components/service";
import { TUser } from "components/user/helpers/user-types-helper";
import usersFuncHelper from "components/user/helpers/user-functions-helper";

type TUserTeamFieldProps = {
    team: TTeam[];
    user?: TUser;
};

const UserTeamField: React.FC<TUserTeamFieldProps> = ({ team, user }) =>
{
    const uniqueTitles: Record<string, boolean> = {};

    const uniqueObjects = team.filter((obj) =>
    {
        const title = obj.title;
        if (uniqueTitles[ title ]) {
            return false;
        } else {
            uniqueTitles[ title ] = true;
            return true;
        }
    });

    return uniqueObjects.length > 0 ? (
        <>
            {uniqueObjects.map((uniqueObj, index) => (
                <div key={index} style={{ marginBottom: "3px" }}>
                    <Link
                        className="table-link-underline"
                        to={`${Team.Const.basePath}/${uniqueObj.id}`}
                    >
                        <span style={{ fontWeight: 400 }}>
                            <Localize>{uniqueObj.title}</Localize>
                            {user && user.id && (() => {
                                const teamRole = usersFuncHelper.getTeamRoleByUserId(uniqueObj, user.id);
                                if (teamRole) {
                                    return (
                                        <span style={{ fontStyle: "italic", fontSize: "12px", opacity: 0.8, marginLeft: "5px" }}>
                                            ({teamRole.split(", ").map((role, i, arr) => (
                                                <React.Fragment key={i}>
                                                    <Localize>{role}</Localize>
                                                    {i < arr.length - 1 && ", "}
                                                </React.Fragment>
                                            ))})
                                        </span>
                                    );
                                }
                                return null;
                            })()}
                        </span>
                    </Link>
                    <br />
                </div>
            ))}
        </>

    ) : (
        <strong>&mdash;</strong>
    );
};

export default UserTeamField;
